import { render, staticRenderFns } from "./LiabilityWidget.vue?vue&type=template&id=5cc771f2&"
import script from "./LiabilityWidget.vue?vue&type=script&lang=js&"
export * from "./LiabilityWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports